module.exports = __webpack_public_path__ + "img/ClickForSound_30.91ad4d71.png";